(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const stickyHeader = document.querySelector('sticky-header');
    if(stickyHeader) {
      stickyHeader.setupWindowResizeEvent();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pb26-collection"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('pb-collection')) {
  customElements.define('pb-collection', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.classList.add('pbc-ready');
      this.abort = new AbortController();
      this.view = new URL(location.href).searchParams.get('view');
      this.preserveLinks();
      this.form = this.querySelector('form');
      this.toggle = this.querySelector('.pbc-filter-toggle');
      this.panel = this.querySelector('.pbc-filters');
      this.media = matchMedia('(max-width: 989px)');
      this.setPanel = () => {
        if (this.panel) this.panel.hidden = this.media.matches;
        if (this.toggle) this.toggle.setAttribute('aria-expanded', String(!this.media.matches));
      };
      this.setPanel();
      this.media.addEventListener('change', this.setPanel, { signal: this.abort.signal });
      this.toggle?.addEventListener('click', () => {
        this.panel.hidden = !this.panel.hidden;
        this.toggle.setAttribute('aria-expanded', String(!this.panel.hidden));
      }, { signal: this.abort.signal });
      this.querySelector('[name="sort_by"]')?.addEventListener('change', () => this.form.requestSubmit(), { signal: this.abort.signal });
      this.form?.addEventListener('submit', event => {
        const min = this.form.querySelector('[name$=".gte"]');
        const max = this.form.querySelector('[name$=".lte"]');
        if (min && max) {
          max.setCustomValidity('');
          if (min.value !== '' && max.value !== '' && Number(min.value) > Number(max.value)) {
            max.value = min.value;
          }
        }
        if (!this.form.reportValidity()) { event.preventDefault(); return; }
        this.form.querySelectorAll('input[type="number"]').forEach(input => { if (input.value === '') input.disabled = true; });
      }, { signal: this.abort.signal });
      this.addEventListener('click', event => {
        const link = event.target.closest('[data-pbc-more]');
        if (!link || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;
        event.preventDefault();
        this.loadMore(link);
      }, { signal: this.abort.signal });
    }
    preserveLinks() {
      if (!this.view) return;
      this.querySelectorAll('[data-pbc-preserve-view]').forEach(link => {
        const url = new URL(link.href, location.origin);
        url.searchParams.set('view', this.view);
        link.href = url.href;
      });
    }
    async loadMore(link) {
      if (this.loading) return;
      this.loading = true;
      const label = link.textContent;
      const status = this.querySelector('.pbc-load-status');
      link.setAttribute('aria-disabled', 'true');
      link.textContent = this.dataset.loading;
      status.textContent = '';
      this.querySelector('.pbc-results').setAttribute('aria-busy', 'true');
      try {
        const url = new URL(link.href);
        if (url.origin !== location.origin) throw new Error('Invalid origin');
        url.searchParams.set('section_id', this.dataset.section);
        const response = await fetch(url, { signal: this.abort.signal });
        if (!response.ok) throw new Error('Fetch failed');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const next = doc.querySelector('pb-collection');
        const grid = this.querySelector('.pbc-products');
        if (!next || !next.querySelector('.pbc-products')) throw new Error('Missing products');
        const seen = new Set([...grid.children].map(card => card.dataset.productId));
        const cards = [...next.querySelectorAll('.pbc-card')].filter(card => !seen.has(card.dataset.productId));
        cards.forEach(card => grid.append(card));
        const pagination = next.querySelector('.pbc-pagination');
        if (pagination) this.querySelector('.pbc-pagination').replaceWith(pagination);
        else this.querySelector('.pbc-pagination').remove();
        this.preserveLinks();
        const first = cards[0]?.querySelector('a');
        first?.focus({ preventScroll: true });
      } catch (error) {
        if (error.name !== 'AbortError') {
          status.textContent = this.dataset.loadError;
          link.removeAttribute('aria-disabled');
          link.textContent = label;
        }
      } finally {
        this.loading = false;
        this.querySelector('.pbc-results')?.removeAttribute('aria-busy');
      }
    }
    disconnectedCallback() { this.abort?.abort(); this.ready = false; }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pb26-header"]) return;
  try {
    
function pb26InitHeader(root) {
  if (!root || root.dataset.ready) return;
  root.dataset.ready = 'true';
  root.querySelectorAll('[data-pb26-localization] form').forEach(form => {
    form.addEventListener('change', event => {
      if (event.target.matches('select')) form.requestSubmit();
    });
    form.classList.add('pb26-localization-ready');
  });
  // Native Shopify predictive search: network requests only after user types.
  // A normal form submission remains available when JS or the suggestion API is unavailable.
  const searchForm = root.querySelector('form.pb26-search');
  if (searchForm) {
    const input = searchForm.querySelector('input[name="q"]');
    const suggestionBox = searchForm.querySelector('.pb26-search-suggest');
    let searchTimer, request, latest = 0;
    const closeSuggestions = () => {
      suggestionBox.hidden = true;
      suggestionBox.replaceChildren();
      input.setAttribute('aria-expanded', 'false');
    };
    function appendSearchResult(item, isCollection) {
      const link = document.createElement('a');
      link.className = 'pb26-suggest-item';
      link.href = item.url;
      if (item.image && item.image.url && /^https:\/\//.test(item.image.url)) {
        const img = document.createElement('img');
        img.src = item.image.url;
        img.alt = '';
        img.loading = 'lazy';
        img.width = 42;
        img.height = 52;
        link.append(img);
      }
      const title = document.createElement('span');
      title.textContent = item.title || '';
      link.append(title);
      if (isCollection) {
        const category = document.createElement('small');
        category.textContent = 'Kategori';
        link.append(category);
      }
      suggestionBox.append(link);
    }
    input.addEventListener('input', () => {
      window.clearTimeout(searchTimer);
      if (request) request.abort();
      const term = input.value.trim();
      const seq = ++latest;
      if (term.length < 2) { closeSuggestions(); return; }
      searchTimer = window.setTimeout(async () => {
        request = new AbortController();
        try {
          const url = new URL(searchForm.dataset.pb26SuggestUrl, window.location.origin);
          url.searchParams.set('q', term);
          url.searchParams.set('resources[type]', 'product,collection');
          url.searchParams.set('resources[limit]', '7');
          const response = await fetch(url, { signal: request.signal });
          if (!response.ok) throw new Error('Search failed');
          const data = await response.json();
          if (seq !== latest || input.value.trim() !== term) return;
          suggestionBox.replaceChildren();
          const results = data.resources?.results || {};
          (results.products || []).slice(0, 6).forEach(product => appendSearchResult(product, false));
          (results.collections || []).slice(0, 2).forEach(collection => appendSearchResult(collection, true));
          const more = document.createElement('a');
          more.className = 'pb26-suggest-all';
          const searchURL = new URL(searchForm.action);
          searchURL.searchParams.set('q', term);
          more.href = searchURL.toString();
          more.textContent = 'Se alle søkeresultater →';
          suggestionBox.append(more);
          suggestionBox.hidden = false;
          input.setAttribute('aria-expanded', 'true');
        } catch (error) {
          if (error.name !== 'AbortError') closeSuggestions();
        }
      }, 210);
    });
    input.addEventListener('keydown', e => {
      if (e.key === 'Escape') { closeSuggestions(); return; }
      if (e.key === 'ArrowDown' && !suggestionBox.hidden) {
        const first = suggestionBox.querySelector('a');
        if (first) { e.preventDefault(); first.focus(); }
      }
    });
    suggestionBox.addEventListener('keydown', e => {
      if (e.key === 'Escape') { e.preventDefault(); closeSuggestions(); input.focus(); }
    });
    searchForm.addEventListener('focusout', e => {
      if (!searchForm.contains(e.relatedTarget)) window.setTimeout(closeSuggestions, 100);
    });
    document.addEventListener('click', e => {
      if (!searchForm.contains(e.target)) closeSuggestions();
    });
  }
  const button = root.querySelector('.pb26-menu-toggle');
  const menu = root.querySelector('.pb26-mobile-menu');
  const setOpen = (open) => { menu.classList.toggle('open', open); button.setAttribute('aria-expanded', String(open)); };
  button.addEventListener('click', () => setOpen(button.getAttribute('aria-expanded') !== 'true'));
  menu.addEventListener('click', e => { if (e.target.closest('a')) setOpen(false); });
  root.addEventListener('keydown', e => { if (e.key === 'Escape') { setOpen(false); root.querySelectorAll('details[open]').forEach(d => d.open = false); button.focus(); } });
  document.addEventListener('click', e => { if (!root.contains(e.target)) { setOpen(false); root.querySelectorAll('details[open]').forEach(d => d.open = false); } });
  root.querySelectorAll('.pb26-navdropdown').forEach(d => d.addEventListener('toggle', () => { if (d.open) root.querySelectorAll('.pb26-navdropdown').forEach(other => { if (other !== d) other.open = false; }); }));
}
document.querySelectorAll('[data-pb26-header]').forEach(pb26InitHeader);
document.addEventListener('shopify:section:load', e => e.target.querySelectorAll('[data-pb26-header]').forEach(pb26InitHeader));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pb26-poster-related"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('pb-poster-related')) {
  customElements.define('pb-poster-related', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.loaded) return;
      this.dataset.loaded = 'true';
      this.hidden = false;
      this.observer = new IntersectionObserver(entries => {
        if (!entries.some(entry => entry.isIntersecting)) return;
        this.observer.disconnect();
        this.loadRecommendations();
      }, {rootMargin: '0px 0px 500px 0px'});
      this.observer.observe(this);
    }
    disconnectedCallback() { this.observer?.disconnect(); }
    async loadRecommendations() {
      try {
        const url = new URL(this.dataset.url, location.origin);
        const params = new URLSearchParams(location.search);
        for (const key of ['view', 'preview_theme_id']) {
          if (params.has(key)) url.searchParams.set(key, params.get(key));
        }
        const response = await fetch(url);
        if (!response.ok) throw new Error('Recommendations unavailable');
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const content = html.querySelector('pb-poster-related');
        if (!content?.querySelector('.pbs-related-card')) { this.hidden = true; return; }
        this.innerHTML = content.innerHTML;
        if (params.get('view') === 'plakat') {
          this.querySelectorAll('.pbs-related-link').forEach(link => {
            const target = new URL(link.href);
            target.searchParams.set('view', 'plakat');
            if (params.has('preview_theme_id')) target.searchParams.set('preview_theme_id', params.get('preview_theme_id'));
            link.href = target.href;
          });
        }
      } catch { this.hidden = true; }
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pb26-standard-related"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('pb-standard-related')) {
  customElements.define('pb-standard-related', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.loaded) return;
      this.dataset.loaded = 'true';
      this.hidden = false;
      this.observer = new IntersectionObserver(entries => {
        if (!entries.some(entry => entry.isIntersecting)) return;
        this.observer.disconnect();
        this.loadRecommendations();
      }, {rootMargin: '0px 0px 500px 0px'});
      this.observer.observe(this);
    }
    disconnectedCallback() { this.observer?.disconnect(); }
    async loadRecommendations() {
      try {
        const url = new URL(this.dataset.url, location.origin);
        const params = new URLSearchParams(location.search);
        for (const key of ['view', 'preview_theme_id']) {
          if (params.has(key)) url.searchParams.set(key, params.get(key));
        }
        const response = await fetch(url);
        if (!response.ok) throw new Error('Recommendations unavailable');
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const content = html.querySelector('pb-standard-related');
        if (!content?.querySelector('.pbs-related-card')) { this.hidden = true; return; }
        this.innerHTML = content.innerHTML;

      } catch { this.hidden = true; }
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
